/**
 * ViewCommander（P0-3d B-1）：在 Canvas 内注册 viewCommand.apply，
 * 把自由视角的相机 + OrbitControls 目标摆到指定位姿（供六向视图按钮调用）。
 * 只在自由视角下有意义；相机视角由 CameraDirector 主导，不在此处抢。
 */
import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

import { viewCommand } from './viewCommand';

/** three-stdlib OrbitControls 的结构化最小依赖面 */
interface OrbitLike {
  target: { set: (x: number, y: number, z: number) => void };
  update: () => void;
}

export function ViewCommander() {
  const camera = useThree((s) => s.camera);
  const controls = useThree((s) => s.controls) as unknown as OrbitLike | null;

  useEffect(() => {
    viewCommand.apply = (pose) => {
      if (controls === null) {
        return;
      }
      camera.position.set(pose.position[0], pose.position[1], pose.position[2]);
      controls.target.set(pose.target[0], pose.target[1], pose.target[2]);
      controls.update();
    };
    return () => {
      viewCommand.apply = () => {
        /* 卸载即复位为空操作 */
      };
    };
  }, [camera, controls]);

  return null;
}
